import { TNode } from "@udecode/plate";


import {  TTrackChangeNodeEntry } from "../types";

export const isTrackChangeText = (node: TNode): node is TTrackChangeNodeEntry => {
  return !!node["trackChanges"];
};